import {FormioBase} from "./formiobase";

export class TextArea extends FormioBase {
  public inputType = "textarea";
  public title = "Text Area";
  public icon = "fa fa-font";
  public schema: any = {
    title: "textarea",
    components: [{
      input: true,
      inputType: "textarea",
      tableView: true,
      label: "TextArea",
      key: undefined,
      placeholder: "",
      prefix: "",
      suffix: "",
      rows: 3,
      multiple: false,
      defaultValue: "",
      protected: false,
      persistent: true,
      wysiwyg: false,
      notvisible: false,
      validate: {
        required: false,
        minLength: 0,
        maxLength: 255,
        pattern: "",
        custom: "",
      },
      type: "textarea",
      tags: [],
      disabled: false,
      description: "",
      tooltip: "",
      customClass: "ds-textarea",
    }],
  };

}
